import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import 'global.module.css';
import { HashRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { QueryClientProvider } from '@tanstack/react-query';
import { theme } from 'styles';
import 'utils/i18n';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from 'utils/query';
import { Router } from 'Router';
import { Notifications } from '@mantine/notifications';
import { initSentry } from 'utils/catchAll';
import { Z_INDEX_VALUES } from 'utils/general';
import { ModalsProvider } from '@mantine/modals';
import { AppProvider } from 'context/AppContext';
import { DrawerProvider } from 'context/DrawerContext';

initSentry();

export const App = () => {
  return (
    <MantineProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <ModalsProvider>
          <Notifications position={'top-right'} zIndex={Z_INDEX_VALUES.notifications} />
          <HashRouter>
            <AppProvider>
              <DrawerProvider>
                <Router />
                <ReactQueryDevtools initialIsOpen={false} />
              </DrawerProvider>
            </AppProvider>
          </HashRouter>
        </ModalsProvider>
      </QueryClientProvider>
    </MantineProvider>
  );
};
